import { Trans } from 'react-i18next';
import { Info } from 'src/svg/Info';

export const ReferralTitle = ({
  onClick,
  isModal = false
}: {
  onClick: () => void;
  isModal?: boolean;
}) => {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="text-white text-lg leading-[26px] font-semibold max-w-[83%] text-text_primary">
        <Trans
          i18nKey="referral.title"
          components={{
            1: <span className="text-text_accent" />
          }}
        />
      </div>

      {!isModal && (
        <Info className="min-w-[36px] max-w-[36px] cursor-pointer mt-[2px]" onClick={onClick} />
      )}
    </div>
  );
};
